import { render } from "./payout.vue?vue&type=template&id=6a728ef1&scoped=true"
import script from "./payout.vue?vue&type=script&lang=js"
export * from "./payout.vue?vue&type=script&lang=js"

import "./payout.vue?vue&type=style&index=0&id=6a728ef1&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a728ef1"]])

export default __exports__